import { ChildAdditionalInformationIcon } from 'assets';
import { childrenTexts } from 'consts/text';
import { Child, ChildDiet, ChildDietDTO } from 'types';
import { DetailsColumn, DetailsRow, DetailsFrameBase } from 'components/atoms';

export type AdditionalInformationProps = Pick<Child, 'diseases' | 'allergies'> & {
    dietDetails?: ChildDiet | ChildDietDTO | null;
};

export const AdditionalInformation = ({
    diseases,
    allergies,
    dietDetails,
}: AdditionalInformationProps) => {
    const getMealsList = () => {
        if (!dietDetails) return '';

        // Handle ChildDietDTO (has meals array)
        if ('meals' in dietDetails && Array.isArray(dietDetails.meals)) {
            return dietDetails.meals.map((meal) => meal.name).join(', ');
        }

        // Handle ChildDiet (has individual boolean properties)
        if ('breakfast' in dietDetails) {
            const meals = [];
            if (dietDetails.breakfast) meals.push('Śniadanie');
            if (dietDetails.soup) meals.push('Zupa');
            if (dietDetails.dinner) meals.push('Obiad');
            if (dietDetails.snack) meals.push('Podwieczorek');
            return meals.join(', ');
        }

        return '';
    };

    const getDietName = () => {
        if (!dietDetails) return '';

        // Handle ChildDiet (has institutionDiet)
        if ('institutionDiet' in dietDetails) {
            return dietDetails.institutionDiet?.name || '';
        }

        // Handle ChildDietDTO (no institutionDiet property)
        return '';
    };

    const filteredMeals = getMealsList();
    const dietName = getDietName();

    return (
        <DetailsFrameBase
            icon={<ChildAdditionalInformationIcon />}
            title={childrenTexts.childDetails.additionalInfo.additionalInfo}
        >
            <DetailsRow>
                <DetailsColumn title={childrenTexts.childDetails.additionalInfo.diet} span={12}>
                    {dietName}
                </DetailsColumn>
                <DetailsColumn title={childrenTexts.childDetails.additionalInfo.meals} span={12}>
                    {filteredMeals}
                </DetailsColumn>
            </DetailsRow>
            <DetailsRow>
                <DetailsColumn title={childrenTexts.childDetails.additionalInfo.diseases}>
                    {diseases}
                </DetailsColumn>
            </DetailsRow>
            <DetailsRow>
                <DetailsColumn title={childrenTexts.childDetails.additionalInfo.allergies}>
                    {allergies}
                </DetailsColumn>
            </DetailsRow>
        </DetailsFrameBase>
    );
};
